document.addEventListener('DOMContentLoaded', ()=>{

    const wrapper = document.getElementById('languageSwitcherWrapper');
    const trigger = document.getElementById('languageSwitcherTrigger');
    const dropdown = document.getElementById('languageSwitcherDropdown');


    if (!wrapper || !trigger) {
        return
    }

    trigger.addEventListener('click', (e)=>{
        e.preventDefault()
        e.stopPropagation()

        const isOpen = wrapper.classList.contains('open');

        if (isOpen){
            closeLangSwitcher()
        }else{
            openLangSwitcher()
        }

    })

    document.addEventListener('click', (e) => {
        const isOpen = wrapper.classList.contains('open');

        if (isOpen && !wrapper.contains(e.target)) {
            closeLangSwitcher();
        }

    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            const isOpen = wrapper.classList.contains('open');
            if (isOpen) {
                closeLangSwitcher();
            }
        }
    });

    function openLangSwitcher() {
        dropdown.style.display = 'block';
        setTimeout(()=>{
            wrapper.classList.add('open')
        },10)

        trigger.setAttribute('aria-expanded', 'true');
    }

    function closeLangSwitcher() {
        wrapper.classList.remove('open')
        setTimeout(()=>{
            dropdown.style.display = 'none';
        },200)

        trigger.setAttribute('aria-expanded', 'false');
    }

})